import styled from 'styled-components';
import { COLOR } from '../../../../../theme/constants';

export const TableFormattedCell = styled.td<{ level: string }>`
   font-size: 16px;
   text-align: center;
   padding: 17px 6px;
   position: relative;
   white-space: nowrap;
   border-top: 1px solid ${COLOR.LIGHTGREY};

   ${props => {
      switch (props.level) {
         case 'L1':
            return `
          color: ${COLOR.BLACK};
        `;
         case 'L2':
            return `
          color: ${COLOR.GREY};
        `;
         case 'L3':
            return `
          color: ${COLOR.GREY};
        `;
      }
   }}
`;
